import { useContext } from 'react';
import { bookingState } from '../client-state/booking-state-context';
import BoatCount from '../../../ui-components/BoatCount';
import usePersonsPerUnit from '../../../Hooks/use-persons-per-unit';
import useBookingTracking from '../../../Hooks/useBookingTracking';
import { bookingActionTypes } from '../client-state/reducers/bookingReducer';
import useBookingMinimalShop from '../server-data/use-booking-minimal-shop';

const BoatCountWithData = () => {
  const { data: minimalShop } = useBookingMinimalShop();
  const { state, dispatch } = useContext(bookingState);
  const personsPerUnit = usePersonsPerUnit();
  const track = useBookingTracking();

  const minBoatCount = 1;
  const maxBoatCount = minimalShop?.maxBoatCount || 12;

  const onAdd = () => {
    if (state.booking.boatCount < maxBoatCount) {
      const newBoatCount = state.booking.boatCount + 1;

      dispatch({ type: bookingActionTypes.UPDATE_BOAT_COUNT, payload: newBoatCount });
      track({ type: 'CHANGE_BOAT_COUNT', boatCount: newBoatCount });
    }
  };

  const onSubtract = () => {
    if (state.booking.boatCount > minBoatCount) {
      const newBoatCount = state.booking.boatCount - 1;

      dispatch({ type: bookingActionTypes.UPDATE_BOAT_COUNT, payload: newBoatCount });
      track({ type: 'CHANGE_BOAT_COUNT', boatCount: newBoatCount });
    }
  };

  return (
    <BoatCount
      boatCount={state.booking.boatCount}
      onAdd={onAdd}
      onSubtract={onSubtract}
      personsPerUnit={personsPerUnit}
      error={state.errors.boatCount}
    />
  );
};

export default BoatCountWithData;
